<template>
  <edit-main @back="goBack"
             :width="'1000px'">
    <template slot="nav">
      <div class="editNav">
        <p class="title">编辑教案</p>
      </div>
    </template>
    <template slot="main">
      <div class="editMain">
        <div class="session_tool">
          <template v-if="flashFlag">
            <object type="application/x-shockwave-flash" id="session_tool" name="session_tool" align="middle" :data="`${hostUrl}/uploads/flash-tool/yioks-preloader.swf?revision=1463`" width="100%"
                    style="margin-top:0px !important;">
              <param name="quality" value="high">
              <param name="bgcolor" value="#ffffff">
              <param name="play" value="false">
              <param name="loop" value="false">
              <param name="wmode" value="opaque">
              <param name="scale" value="showall">
              <embed wmode="opaque"/>
              <param name="menu" value="true">
              <param name="devicefont" value="false">
              <param name="salign" value="">
              <param name="allowscriptaccess" value="sameDomain">
              <param name="allowfullscreen" value="true">
              <param name="allowFullScreenInteractive" value="true">
              <param name="base" value="images/flash">
              <param name="flashvars"
                     :value="`selectedMovie=${hostUrl}/uploads/flash-tool/yioks-football-editor.swf&amp;xmlRequestFile=/api/xml/tactical_data?plan_id=${plan_id}%26uid%3d${tutorial_uid}%26member_type%3d${type}%26gotourl=${gotoUrl}&amp;globalRequestFile=/api/xml/global_data&amp;revision=1464`">
            </object>
          </template>
          <template v-if="flashTipsFlag">
            <flash-tips></flash-tips>
          </template>
        </div>
      </div>
      <yioks-tips :showTips="tipsFlag"
                  :tips="'确定放弃修改并返回吗？'"
                  @hideTips="hideTipsDialog"></yioks-tips>
    </template>
  </edit-main>
</template>

<script>
  export default {
    name: "edit-tutorial",
    data() {
      const userInfo = this.$store.state.userInfo;
      const hostUrl = process.env.VUE_APP_URL;
      const plan_id = this.$route.query.plan_id;
      const goto = this.$route.query.goto;
      const type = this.$route.query.type;
      let gotoUrl=''
      if (type){
       gotoUrl = `teacher/tutorial_detail?id=${plan_id}@goto=${goto}`;
      }else{
       gotoUrl = `student/tutorial_detail?id=${plan_id}@goto=${goto}`;
      }
      return {
        tutorial_uid: userInfo.uid,
        hostUrl,
        plan_id,
        type:type ? type : '',
        gotoUrl,
        flashFlag: false,
        tipsFlag: false,
        flashTipsFlag: false,
      };
    },
    components: {
      "edit-main": () => import("@/components/LayOut/Common/up-down"),
      "flash-tips": () => import("@/components/Tutorial/flash-tips"),
      "yioks-tips": () => import("@/components/Tips/Dialog")
    },
    created() {
      this.flashFlag = this.$yioks.flashChecker();
      this.flashTipsFlag = !this.flashFlag;
    },
    methods: {
      goBack() {
        //this.$router.go(-1);
        this.tipsFlag = true;
      },
      hideTipsDialog(bool, sure) {
        this.tipsFlag = bool;
        if (sure) {
          this.$router.go(-1);
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .editNav, .editMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .editNav {
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .editMain {
    width: 100%;
    .session_tool {
      width: 100%;
      height: 600px;
      background-color: $block_bg_color_base;
      #session_tool {
        height: 600px;
      }
    }
  }
</style>
